module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-back",
      "title": "Ritorno"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1cb1382a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Back.vue
// module id = 830
// module chunks = 39